function getBuyerId() {
    return JSON.parse(document.getElementsByTagName('html')[0].dataset.buyerId) || null;
}

export {
    getBuyerId,
};
